import gsap from "gsap";
import { ScrollTrigger } from "gsap/src/all";

export const aniFeaturedProduct = (root: React.MutableRefObject<null>) => {
    const componentSelector = gsap.utils.selector(root);
    gsap.defaults({ ease: "power2.inOut", duration: 0.75 });

    gsap.set(componentSelector("#tagline"), { opacity: 0 });

    ScrollTrigger.create({
        trigger: componentSelector("#tagline"),
        start: "top 80%",

        // start: 'bottom 75%-=500px',
        // end: 'bottom 75%-=500px',

        once: true,
        onEnter: () => {
            console.log("FEATURED, onEnter");
            gsap.to(componentSelector(".product-tagline"), {
                opacity: 1,
            });
        },
    });
    const id = (root.current as HTMLElement | null)?.id;
    console.log("🚙 FeaturedProductAnimations", id);
};

export const aniFeaturedProductKill = (root: React.MutableRefObject<null>) => {
    gsap.killTweensOf(root.current);
    const id = (root.current as HTMLElement | null)?.id;
    console.log("🚗 FeaturedProductAnimations killed", id);
};
